import { useInfiniteQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

interface IProps {
  limit: number;
  name?: string;
}

export const useOrderApprovalChainQuery = ({ limit, name }: IProps) => {
  return useInfiniteQuery({
    queryKey: ['getOrderApprovalChainSelect', name],
    queryFn: async ({ pageParam = 0 }) => {
      return await Api.users.getOrderApprovalChains({
        name: name,
        offset: pageParam,
        limit,
        include_chains_links: false,
        order_by: 'name',
      });
    },
    getNextPageParam: (current, allPages) => {
      const count = allPages.length * (limit || 1);
      return count >= (current.total || 0) ? undefined : count;
    },
  });
};
